import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19391 19391"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#fefefe;stroke-width:1077.29}.str1{stroke:#2b2a29}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313898304">
        <path
          d="M540 5709v1633M18852 5709v1633"
          className="fill stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
        <path
          d="M539 5996h3052v11331c0 839-687 1526-1526 1526-840 0-1526-687-1526-1526V5996zM3591 5996h3052v11331c0 839-686 1526-1526 1526s-1526-687-1526-1526V5996zM12751 5996h3052v11331c0 839-687 1526-1526 1526-840 0-1526-687-1526-1526V5996z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
        <path
          d="M15800 5996h3052v11331c0 839-687 1526-1526 1526-840 0-1526-687-1526-1526V5996zM1182 539h17027c354 0 643 289 643 642v4528H539V1181c0-353 289-642 643-642z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
